// extracted by mini-css-extract-plugin
module.exports = {"container":"JackpotCountdown_container__24FCt","tiny":"JackpotCountdown_tiny__3DfYh","dummy":"JackpotCountdown_dummy__2F4TN"};